/** Helpers de aprobación de Órdenes de Compra: solo una OC aprobada se puede imprimir/descargar. */
import { OrdenCompra } from '../services/ordenCompraService';
import { getApiErrorMessage } from './apiError';

export const PERMISO_APROBAR_ORDEN_COMPRA = 'compras.ordenes.aprobar';
export const PERMISO_IMPRIMIR_ORDEN_COMPRA = 'compras.ordenes.imprimir';

export const esOrdenCompraAprobada = (oc: Pick<OrdenCompra, 'fechaAprobacion'>): boolean =>
  Boolean(oc.fechaAprobacion);

export const getAprobarOrdenCompraErrorMessage = (error: unknown): string => {
  const status = (error as { response?: { status?: number } })?.response?.status;
  if (status === 404 || status === 405) {
    return 'La API no tiene el endpoint para aprobar la orden (POST .../aprobar). Pedile a backend que lo habilite.';
  }
  return getApiErrorMessage(error, 'Error al aprobar la orden de compra');
};
